import { useState } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Logo1 from '../Assets/Assests/Logos/Tesla bird logo.png'
import Navbar from './Navbar'

const ConfirmationForm = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    mobile_number: '',
    email_id: '',
    message: '',
    residential_address: '',
    pincode: '',
    quantity: 1,
  })

  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)
  const UNIT_PRICE = 2499

  const validateField = (name, value) => {
    let errors = { ...error }

    if (!value.toString().trim()) {
      errors[name] = `${name.replace('_', ' ')} is required`
    } else {
      switch (name) {
        case 'name':
          if (!/^[A-Za-z\s]{3,}$/.test(value)) {
            errors[name] = 'Name must be at least 3 letters'
          } else delete errors[name]
          break
        case 'email_id':
          if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
            errors[name] = 'Invalid email address'
          } else delete errors[name]
          break
        case 'mobile_number':
          if (!/^\+(?:[0-9] ?){6,14}[0-9]$/.test(value)) {
            errors[name] = 'Enter valid mobile number with country code'
          } else delete errors[name]
          break
        case 'residential_address':
          if (value.trim().length < 10) {
            errors[name] = 'Address must be at least 10 characters'
          } else delete errors[name]
          break
        case 'pincode':
          if (!/^\d{6}$/.test(value)) {
            errors[name] = 'Pincode must be exactly 6 digits'
          } else delete errors[name]
          break
        default:
          delete errors[name]
      }
    }
    setError(errors)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'quantity' ? Math.max(1, Number(value)) : value,
    }))
    validateField(name, value)
  }

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const existingScript = document.getElementById('razorpay-script')
      if (!existingScript) {
        const script = document.createElement('script')
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        script.id = 'razorpay-script'
        script.onload = () => resolve(true)
        script.onerror = () => resolve(false)
        document.body.appendChild(script)
      } else {
        resolve(true)
      }
    })
  }

  const handlePayment = async (orderData) => {
    const options = {
      //key: 'rzp_test_XF9v6oecgVPv6f', // Replace with your Razorpay key
      key: 'rzp_live_C6kUQM5U7CPGxp',
      amount: orderData.amount * 100,
      currency: 'INR',
      name: 'Tesla Bird',
      description: 'Kit Purchase',
      order_id: orderData.order_id,
      handler: async function (response) {
        // console.log('Razorpay Response:', response)

        try {
          await axios.put(
            'https://aimuseumbackend.teslabird.com/api/verify-kit-payment/',
            {
              order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            },
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('access')}`,
              },
            }
          )

          Swal.fire({
            icon: 'success',
            title: 'Payment Successful',
            text: 'Thank you for your support! You get an mail with details.',
            confirmButtonColor: '#002740',
          })
          navigate('/home')
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Verification Failed',
            text: 'Payment succeeded but verification failed.',
          })
        }
      },
      theme: {
        color: '#002740',
      },
    }

    const rzp = new window.Razorpay(options)
    rzp.open()
  }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()
  //   const newErrors = {}

  //   Object.keys(formData).forEach((key) => {
  //     if (!formData[key] && key !== 'message') {
  //       newErrors[key] = `${key.replace('_', ' ')} is required`
  //     }
  //   })

  //   if (Object.keys(newErrors).length > 0) {
  //     setError(newErrors)
  //     return
  //   }

  //   setLoading(true)

  //   let orderResponse
  //   try {
  //     const payload = {
  //       name: formData.name,
  //       mobile_number: formData.mobile_number,
  //       email: formData.email_id,
  //       address: formData.residential_address,
  //       pincode: formData.pincode,
  //       quantity: formData.quantity,
  //     }

  //     orderResponse = await axios.post(
  //       'https://aimuseumbackend.teslabird.com/api/order-kit/',
  //       payload,
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           Authorization: `Bearer ${localStorage.getItem('access')}`,
  //         },
  //       }
  //     )
  //   } catch (err) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Order Failed',
  //       text: 'Unable to create order. Try again later.',
  //     })
  //     setLoading(false)
  //     return
  //   }

  //   // Safely call Razorpay handler
  //   if (orderResponse?.data?.order_id) {
  //     await handlePayment(orderResponse.data)
  //   } else {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Invalid Razorpay Order',
  //       text: 'Razorpay order ID missing. Contact support.',
  //     })
  //   }

  //   setLoading(false)
  // }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const newErrors = {}

    Object.keys(formData).forEach((key) => {
      if (!formData[key] && key !== 'message') {
        newErrors[key] = `${key.replace('_', ' ')} is required`
      }
    })

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      return
    }

    setLoading(true)

    // Load Razorpay script
    const isScriptLoaded = await loadRazorpayScript()
    if (!isScriptLoaded) {
      Swal.fire({
        icon: 'error',
        title: 'Script Load Failed',
        text: 'Failed to load Razorpay script. Please try again later.',
      })
      setLoading(false)
      return
    }

    let orderResponse
    try {
      const payload = {
        name: formData.name,
        mobile_number: formData.mobile_number,
        email: formData.email_id,
        address: formData.residential_address,
        pincode: formData.pincode,
        quantity: formData.quantity,
      }

      orderResponse = await axios.post(
        'https://aimuseumbackend.teslabird.com/api/order-kit/',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access')}`,
          },
        }
      )
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Order Failed',
        text: 'Unable to create order. Try again later.',
      })
      setLoading(false)
      return
    }

    if (orderResponse?.data?.order_id) {
      await handlePayment(orderResponse.data)
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Razorpay Order',
        text: 'Razorpay order ID missing. Contact support.',
      })
    }

    setLoading(false)
  }

  return (
    <>
      <Navbar />
      <Container
        fluid
        className='min-vh-100 d-flex justify-content-center align-items-center'
      >
        <Row className='w-100 justify-content-center'>
          <Col xs={12} md={6} lg={4} className='p-4'>
            <a href='/'>
              <img
                src={Logo1}
                alt='Logo'
                className='img-fluid d-block d-md-none mb-3'
                style={{ width: '120px' }}
              />
            </a>
            <Card
              className='shadow-lg rounded-4 p-4 w-100'
              style={{ maxWidth: '400px' }}
            >
              <Card.Body>
                <h2 className='fw-bold mb-3'>Payment Details Form</h2>

                {Object.keys(error).length > 0 && (
                  <Alert variant='danger'>
                    {Object.values(error).map((err, idx) => (
                      <div key={idx}>{err}</div>
                    ))}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  {[
                    { label: 'Full Name', name: 'name' },
                    { label: 'Contact No.', name: 'mobile_number' },
                    { label: 'Email', name: 'email_id' },
                  ].map((field, idx) => (
                    <Form.Group className='mb-3' key={idx}>
                      <Form.Label className='text-muted small'>
                        {field.label}
                      </Form.Label>
                      <Form.Control
                        type='text'
                        name={field.name}
                        placeholder={`Enter ${field.label.toLowerCase()}`}
                        value={formData[field.name]}
                        onChange={handleChange}
                        className='border-0 border-bottom'
                        style={{ color: 'black' }}
                        isInvalid={!!error[field.name]}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {error[field.name]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  ))}

                  <Form.Group className='mb-3'>
                    <Form.Label className='text-muted small'>
                      Quantity
                    </Form.Label>
                    <Form.Control
                      type='number'
                      name='quantity'
                      min='1'
                      value={formData.quantity}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                    />
                  </Form.Group>

                  <div className='mb-3 text-end fw-bold text-muted'>
                    Total: ₹{formData.quantity * UNIT_PRICE}
                  </div>

                  <Form.Group className='mb-3'>
                    <Form.Label className='text-muted small'>
                      Residential Address
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      name='residential_address'
                      value={formData.residential_address}
                      onChange={handleChange}
                      rows={2}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                      isInvalid={!!error.residential_address}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error.residential_address}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className='mb-3'>
                    <Form.Label className='text-muted small'>
                      Pincode
                    </Form.Label>
                    <Form.Control
                      type='text'
                      name='pincode'
                      maxLength={6}
                      placeholder='Enter 6-digit pincode'
                      value={formData.pincode}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }} // ✅ Ensure black typing
                      isInvalid={!!error.pincode}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error.pincode}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className='mb-3'>
                    <Form.Label className='text-muted small'>
                      Message
                    </Form.Label>
                    <Form.Control
                      as='textarea'
                      name='message'
                      value={formData.message}
                      onChange={handleChange}
                      rows={2}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                    />
                  </Form.Group>
                  <Button
                    type='submit'
                    className='w-100 text-white rounded-pill'
                    style={{ backgroundColor: '#002740' }}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation='border' size='sm' />
                    ) : (
                      'Pay Now'
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default ConfirmationForm
